import { saved } from 'constants/global/messages';
import type { Notification } from 'types/common/notification';

const billingUpdateSuccess: Notification = {
  id: 'billing/update/success',
  type: 'success',
  content: saved('Billing information'),
};

const NOTIFICATION_BILLING = {
  billingUpdateSuccess,
};

export default NOTIFICATION_BILLING;
